export async function runSafely<T extends any | undefined>(
  func: () => any
): Promise<T> {
  try {
    return await func()
  } catch (e) {
    return undefined
  }
}
